import { render, staticRenderFns } from "./UiTableOrderReport.vue?vue&type=template&id=c1a24ce4&scoped=true"
import script from "./UiTableOrderReport.vue?vue&type=script&lang=js"
export * from "./UiTableOrderReport.vue?vue&type=script&lang=js"
import style0 from "./UiTableOrderReport.vue?vue&type=style&index=0&id=c1a24ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a24ce4",
  null
  
)

export default component.exports